import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import React, {forwardRef} from 'react';
import FlashMessage from 'react-native-flash-message';
import {
  initialWindowMetrics,
  SafeAreaProvider,
} from 'react-native-safe-area-context';
// import {useSelector} from 'react-redux';
import {isWebDesktopView} from '../utils';
import {AUTHENTICATED_ROUTES, UN_AUTHENTICATED_ROUTES} from './constants';
const {Navigator, Screen} = createStackNavigator();

const linking = {};

const AppNavigator = forwardRef((props, ref) => {
  // const isAuthenticated = useSelector((state) =>
  //   Boolean(state.auth.accessToken),
  // );
  const initRoute = UN_AUTHENTICATED_ROUTES.authLoading.path;

  // const ROUTES = isAuthenticated
  //   ? AUTHENTICATED_ROUTES
  //   : UN_AUTHENTICATED_ROUTES;

  const ROUTES = {...AUTHENTICATED_ROUTES, ...UN_AUTHENTICATED_ROUTES};

  let isWebDesktop = isWebDesktopView();

  return (
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      <NavigationContainer linking={linking} ref={ref}>
        <Navigator
          initialRouteName={initRoute}
          headerMode="none"
          {...(isWebDesktop
            ? {
                mode: 'modal',
                screenOptions: {cardStyle: {backgroundColor: 'transparent'}},
              }
            : {
                screenOptions: {gestureEnabled: false},
              })}>
          {Object.values(ROUTES).map(({component, path}) => (
            <Screen name={path} component={component} key={path} />
          ))}
        </Navigator>
      </NavigationContainer>
      <FlashMessage />
    </SafeAreaProvider>
  );
});

export default AppNavigator;
